import { getAssessmentById } from '@/data/assessments'
import { AssessmentDetailPage } from './AssessmentDetailPage'

export function AIAssessment() {
  const assessment = getAssessmentById('ai')!
  return <AssessmentDetailPage assessment={assessment} />
}
